import React from "react";
import { useHistory } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import Swal from "sweetalert2";

import ImpresionAutorizacion from "../components/content/ImpresionAutorizacion.jsx";

class ImpresionMV extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick_I = this.handleClick_I.bind(this);
    this.handleClick_N = this.handleClick_N.bind(this);
    this.handleClick_IADA = this.handleClick_IADA.bind(this);
    this.handleClick_NADA = this.handleClick_NADA.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.closeModalAutorizacion = this.closeModalAutorizacion.bind(this);

    this.state = {
      previa: false,
      nivelUsuario: localStorage.nivel_actual,
      previa_url: "",
      subproductoCombo: Api.loadCatalogue("cat_subproducto_tipo"),
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),

      buscar: "",
      previa_ada: false,
      working: false,
      autorizacion: {},
      buscar_ada: "",

      collapse: [
        {
          id: 1,
          collapse: true,
        },
        {
          id: 2,
          collapse: false,
        },
        {
          id: 3,
          collapse: false,
        },
      ],
      activeTab: "1",

      marchamo: "",
    };
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  }

  busqueda = {};
  mi_grid = {};
  bAutorizacion = {};
  autorizaciones = {};
  componentDidMount() {
    // si el usuario no es nivel medico veterinario ipsa redireccionamos a home
    if (this.state.nivelUsuario !== "7") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getImpresionMV",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio: {
          label: "Folio precertificado y/o constancia de exportacion",
        },
        fecha_emision: {
          label: "Fecha de expedición del Precertificado",
        },
        fecha_vencimiento: {
          label: "Fecha de vencimiento del Precertificado",
        },
        tipo_subproducto: {
          label: "Tipo subproducto",
        },
      },
      buttons: [
        {
          //name: "abrir",
          btnClass: "btn btn-primary",
          iconClass: "fa fa-print",
          title: "Imprimir",
          btnClick: (data) => {
            this.handleClick_I(data.id);
          },
          render: (me, data) => {},
        },
        {
          //name: "abrir",
          btnClass: "btn btn-yellow",
          iconClass: "fa fa-bell",
          title: "Notificar",
          btnClick: (data) => {
            this.handleClick_N(data.id);
          },
          render: (me, data) => {},
        },
      ],
    };

    this.mi_grid = Api.grid(grid);

    this.busqueda = Api.form({
      target: "#busqueda",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio_pre",
            label: "Folio precertificado y/o constancia de exportacion",
            placeHolder: "Ingresa el folio",
            cols: 3,
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_e",
            label: "Fecha de expedición",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha_v",
            label: "Fecha de vencimiento",
            cols: 2,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "subproducto_tipo_id",
            label: "Tipo subproducto",
            cols: 3,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.subproductoCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar: this.busqueda.data() });
              let search = this.state.buscar;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }
              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });

    let autorizacion = {
      source: "app/getImpresionAutorizacionMedico",
      target: "#myAtorizacion",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio: {
          label: "Folio",
        },
        folio_solicitud: {
          label: "Folio solicitud",
        },
        razon_social: {
          label: "Establecimiento",
        },
        fecha_solicitud: {
          label: "fecha",
          render: (me) => {
            me.innerHTML = me.data.fecha_solicitud
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        } /* 
        estatus: {
          label: "Estado",
        }, */,
      },
      buttons: [
        {
          //name: "abrir",
          btnClass: "btn btn-primary",
          iconClass: "fa fa-print",
          title: "Imprimir",
          btnClick: (data) => {
            this.handleClick_IADA(data.sol_id);
          },
          render: (me, data) => {},
        },
        /*  {
          //name: "abrir",
          btnClass: "btn btn-yellow",
          iconClass: "fa fa-bell",
          title: "Notificar",
          btnClick: (data) => {
            this.handleClick_NADA(data.id);
          },
          render: (me, data) => {},
        }, */
      ],
    };
    this.autorizaciones = Api.grid(autorizacion);

    /* BUSQUEDA AUTORIZACION*/
    this.bAutorizacion = Api.form({
      target: "#busquedaAutorizacion",
      nombre: "busquedaAutorizacion",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 6,
            name: "folio",
            type: "text",
            label: "Folio",
            placeHolder: "Folio",
          },
        },
        {
          input: {
            cols: 6,
            name: "folio_solicitud",
            type: "text",
            label: "Folio solicitud",
            placeHolder: "Folio de la solicitud",
          },
        },
        {
          input: {
            cols: 4,
            name: "razon_social",
            type: "text",
            label: "Establecimiento",
            placeHolder: "Establecimiento",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha",
            type: "date",
            label: "Fecha desde",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha2",
            type: "date",
            label: "Fecha hasta",
          },
        },
        /* {
          select: {
            cols: 2,
            name: "estatus",
            label: "Estatus",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        }, */
        {
          button: {
            cols: 2,
            name: "buscarAutorizacion",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscar_ada: this.bAutorizacion.data() });
              let search = this.state.buscar_ada;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }
              this.autorizaciones.go(1, src);
            },
          },
        },
      ],
    });
    /* Termina buscador AUTORIZACION */
  }

  handleClick_I(id) {
    this.setState({
      previa: true,
      previa_url: Api.url + `app/precertificadpce/?id=${id}`,
    });

    /**MODIFICAR IMPRESIONES */
    Api.fetch(
      "app/imprimirPrecertificado",
      {
        id: id,
        //impresnes = this.state.
      },
      "PUT"
    ).then((response) => {
      /**no hace nada? */
    });
  }

  handleClick_N(id) {
    /**NOTIFICAR EL USUARIO */
    Api.fetch(
      "app/updateClientNotificacion",
      {
        id: id,
      },
      "PUT"
    ).then((response) => {
      Swal.fire({
        icon: "success",
        text: response.message,
      }).then((result) => {
        if (result.isConfirmed) {
          this.mi_grid.go(1);
        }
      });
    });
  }

  handleClick_IADA(id) {
    this.setState({
      previa_ada: true,
      working: true,
    });
    Api.fetch("app/getSolicitudAutorizacionDA?solicitud_id=" + id).then((a) => {
      let marchamo = this.state.marchamo;
      let lm = a.lista_marchamos;
      for (let i in lm) {
        marchamo = marchamo + ", " + lm[i].numero_marchamo;
      }

      this.setState({
        autorizacion: a,
        working: false,
        marchamo: marchamo.slice(2),
      });
    });
  }

  handleClick_NADA(id) {
    /**NOTIFICAR EL USUARIO */
    Api.fetch(
      "app/updateClientNotificacion",
      {
        id: id,
      },
      "PUT"
    ).then((response) => {
      Swal.fire({
        icon: "success",
        text: response.message,
      }).then((result) => {
        if (result.isConfirmed) {
          this.autorizaciones.go(1);
        }
      });
    });
  }

  closeModalAutorizacion() {
    this.setState({ previa_ada: false });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">Home</li>
          <li className="breadcrumb-item active">Impresiones</li>
        </ol>
        <h1 className="page-header">Impresiones</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    Precertificado y/o certificado de exportación
                    {/*  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pce}
                  </span> */}
                  </span>
                  <span className="d-sm-block d-none">
                    Precertificado y/o certificado de exportación
                    {/* <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_pce}
                  </span> */}
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "2",
                  })}
                  onClick={() => {
                    this.toggleTab("2");
                  }}
                >
                  <span className="d-sm-none">
                    Autorización de adquisición
                    {/*  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ada}
                  </span> */}
                  </span>
                  <span className="d-sm-block d-none">
                    Autorización de adquisición
                    {/* <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ada}
                  </span> */}
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Panel>
              <PanelBody>
                <div className="row">
                  <div className="col-sm-12">
                    <fieldset>
                      <div id="busqueda"></div>
                    </fieldset>
                    <div id="myGrid"></div>
                  </div>
                </div>
              </PanelBody>
            </Panel>
          </TabPane>
          <TabPane tabId="2">
            <Panel>
              <PanelBody>
                <div className="row">
                  <div className="col-sm-12">
                    <fieldset>
                      <div id="busquedaAutorizacion"></div>
                    </fieldset>
                    <div id="myAtorizacion"></div>
                  </div>
                </div>
              </PanelBody>
            </Panel>
          </TabPane>
        </TabContent>
        <div className={this.state.previa ? "previa" : "hide"}>
          <iframe
            title="Vista previa"
            className="rounded"
            src={this.state.previa_url}
            loading="eager"
          ></iframe>
          <center>
            <div className="btn-group">
              <button
                onClick={() => {
                  this.setState({ previa: false });
                }}
                className="btn btn-danger"
              >
                Regresar
              </button>
              <a
                className="btn btn-primary"
                href={this.state.previa_url + "&download=1"}
                download="download"
              >
                Descargar
              </a>
            </div>
          </center>
        </div>
        {/**AUTORIAZCIÓN*/}
        <ImpresionAutorizacion
          key={this.state.autorizacion.solicitud_id}
          component={this}
          state={this.state}
          change={this.closeModalAutorizacion}
        />
        {/** FIN */}
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <ImpresionMV auth={auth} history={history} {...props} />;
};
